import { useParams } from "react-router-dom";

export const Surgeons = () => {
  const { id } = useParams();
  const path = `/surgeons/${id}.html`;
  return (
    <iframe
      title={"Surgeons"}
      src={path}
      style={{ width: "100vw", height: "100vh" }}
    />
  );
};
